import { $fetch } from 'ofetch'

const UPLOAD_META_TIMEOUT_MS = 30_000

export type UploadMetaSyncItem = {
  id: string
  name?: string | null
  productId?: number | null
  categoryId?: number | null
  meta: Record<string, any> | null
}

export async function syncUploadMeta(opts: {
  editorBaseUrl: string
  projectCode: string
  id: string
  productId?: number | null
  categoryId?: number | null
  meta: Record<string, any> | null
}) {
  const base = String(opts.editorBaseUrl || '').replace(/\/+$/, '')
  const id = String(opts.id || '').trim()
  const projectCode = String(opts.projectCode || '').trim()
  if (!base || !id || !projectCode) return null

  return await $fetch(`${base}/upload/${encodeURIComponent(id)}/meta`, {
    method: 'PATCH',
    timeout: UPLOAD_META_TIMEOUT_MS,
    body: {
      projectCode,
      ...(String((opts as any).name || '').trim() ? { name: String((opts as any).name).trim() } : {}),
      ...(opts.productId != null ? { productId: Number(opts.productId || 0) || 0 } : {}),
      ...(opts.categoryId != null ? { categoryId: Number(opts.categoryId || 0) || 0 } : {}),
      meta: opts.meta ?? null,
    },
  }).catch((err) => {
    // Keep the null fallback so callers don't break, but surface the failure for diagnostics.
    console.warn(`[uploadMetaApi] syncUploadMeta failed for id=${id}`, err)
    return null
  })
}

export async function syncUploadMetaBatch(opts: {
  editorBaseUrl: string
  projectCode: string
  items: UploadMetaSyncItem[]
}) {
  const base = String(opts.editorBaseUrl || '').replace(/\/+$/, '')
  const projectCode = String(opts.projectCode || '').trim()
  const items = Array.isArray(opts.items)
    ? opts.items
        .map((item) => ({
          id: String(item?.id || '').trim(),
          ...(String(item?.name || '').trim() ? { name: String(item.name).trim() } : {}),
          ...(item?.productId != null ? { productId: Number(item.productId || 0) || 0 } : {}),
          ...(item?.categoryId != null ? { categoryId: Number(item.categoryId || 0) || 0 } : {}),
          meta: item?.meta ?? null,
        }))
        .filter((item) => !!item.id)
    : []
  if (!base || !projectCode || !items.length) return []

  const response = await $fetch(`${base}/upload/meta-batch`, {
    method: 'PATCH',
    timeout: UPLOAD_META_TIMEOUT_MS,
    body: {
      projectCode,
      items,
    },
  }).catch((err) => {
    // Keep the [] fallback so callers don't break, but surface the failure for diagnostics.
    console.warn(`[uploadMetaApi] syncUploadMetaBatch failed (${items.length} items)`, err)
    return null as any
  })

  return Array.isArray((response as any)?.items) ? (response as any).items : []
}
